import { CopyOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./copybutton.module.scss";

const CopyButton = ({
  title,
  onClick,
  className = "",
}: { title?: string; onClick: () => void; className?: string }) => {
  const componentName = "copybutton";
  return (
    <Button
      type="default"
      className={`${styles[`${componentName}__button`]} ${className}`}
      onClick={onClick}
      icon={<CopyOutlined />}
    >
      {title ? title : "Copy"}
    </Button>
  );
};

export default CopyButton;
